import {
  FETCH_TASKS,
  FETCH_TASKS_SUCCESS,
  FETCH_TASKS_FAILED,
  ACCEPT_TASK,
  CANCEL_TASK,
  FETCH_NEW_BOOKINGS_SUCCESS,
} from "../store/types";
import store from "../store/store";
import { updateProfile } from "./authactions";
import { RequestPushMsg } from "../other/NotificationFunctions";
import { firebase } from "../config/configureFirebase";
import { checkTripUsage } from "./subscriptionactions";
import { onValue, runTransaction, get, off, push } from "firebase/database";
import { Platform } from "react-native";

export const fetchTasks = () => async (dispatch) => {
  const { auth, tasksRef } = firebase;

  const uid = auth.currentUser.uid;
  off(tasksRef());
  dispatch({
    type: FETCH_TASKS,
    payload: null,
  });

  // Check driver subscription first
  let canTakeTasks = true;
  try {
    const subscriptionCheck = await dispatch(checkTripUsage(uid, 'check', 'driver'));
    if (subscriptionCheck && !subscriptionCheck.canTakeTrip) {
      canTakeTasks = false;
      console.log("Driver subscription check failed:", subscriptionCheck.reason);
    }
  } catch (error) {
    console.error("Error checking driver subscription:", error);
    // Continue if subscription check fails
  }

  onValue(tasksRef(), (snapshot) => {
    if (snapshot.val()) {
      let data = snapshot.val();
      
      // Filter tasks based on subscription status
      const arr = Object.keys(data)
        .filter(
          (i) => data[i].requestedDrivers && data[i].requestedDrivers[uid]
        )
        .map((i) => {
          data[i].id = i;
          return data[i];
        })
        .filter(() => canTakeTasks); // Only show tasks if driver has valid subscription

      const userInfo = store.getState().auth.profile;
      let heatpoints = [];
      let bookings = Object.values(snapshot.val());
      for (let i = 0; i < bookings.length; i++) {
        if (bookings[i].status == "NEW") {
          // Check if driver can handle this car type
          let canHandleCarType = false;
          
          // Get settings to check if multi-service is enabled
          const settings = store.getState().settingsdata.settings;
          
          if (userInfo.hasOwnProperty("carType")) {
            // For multi-service system, check cars collection and ignore category
            if (settings && settings.multi_service) {
              // Note: For multi-service, car type validation is handled by client side
              // when fetching cars from cars collection. Here we assume driver has valid cars.
              canHandleCarType = true;
            }
            // For single-service system, check carType only
            else {
              canHandleCarType = userInfo.carType === bookings[i].carType;
            }
          } else {
            canHandleCarType = true; // No car type requirement
          }
          
          if (canHandleCarType && canTakeTasks) {
            heatpoints.push({
              latitude: bookings[i].pickup.lat,
              longitude: bookings[i].pickup.lng,
              weight: 1,
            });
          }
        }
      }
      dispatch({
        type: FETCH_NEW_BOOKINGS_SUCCESS,
        payload: heatpoints,
      });

      dispatch({
        type: FETCH_TASKS_SUCCESS,
        payload: arr,
      });
    } else {
      dispatch({
        type: FETCH_TASKS_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_tasks,
      });
    }
  });
};

export const acceptTask = (task) => async (dispatch) => {
  const { auth, trackingRef, singleUserRef, singleBookingRef, carsRef } = firebase;

  const uid = auth.currentUser.uid;

  // Check subscription before accepting task
  try {
    const subscriptionCheck = await dispatch(checkTripUsage(uid, 'check', 'driver'));
    if (subscriptionCheck && !subscriptionCheck.canTakeTrip) {
      console.log("Driver subscription check failed:", subscriptionCheck.reason);
      
      // Show alert to driver about subscription requirement
      if (Platform.OS === 'web') {
        alert(subscriptionCheck.reason || "Subscription required to accept tasks");
      } else {
        // For React Native, you would need to pass a callback or use a different approach
        console.log("Driver needs subscription:", subscriptionCheck.reason);
      }
      
      return; // Don't accept task if subscription check fails
    }
  } catch (error) {
    console.error("Error checking driver subscription:", error);
    // Continue with accepting task if subscription check fails
  }

  onValue(
    singleUserRef(uid),
    (snapshot) => {
      let profile = snapshot.val();

      // Get vehicle_number from cars collection
      let vehicleNumber = "";
      const carsReference = carsRef(uid, "driver");
      
      onValue(carsReference, (carsSnapshot) => {
        if (carsSnapshot.val()) {
          const cars = carsSnapshot.val();
          // Find the first car group for this driver
          Object.keys(cars).forEach(carGroupId => {
            const carGroup = cars[carGroupId];
            if (carGroup.driver === uid && carGroup.vehicleNumber) {
              vehicleNumber = carGroup.vehicleNumber;
            }
          });
        }
      }, { onlyOnce: true });

      runTransaction(singleBookingRef(task.id), (booking) => {
        let fleetCommission_fee = profile.fleetadmin
          ? (
              ((parseFloat(booking.estimate) -
                parseFloat(booking.convenience_fees)) *
                parseFloat(booking.fleet_admin_comission)) /
              100
            ).toFixed(2)
          : 0;
        let driver_fee = parseFloat(
          parseFloat(booking.estimate) -
            (parseFloat(booking.convenience_fees) +
              parseFloat(fleetCommission_fee))
        ).toFixed(2);
        if (booking && booking.requestedDrivers) {
          booking.driver = uid;
          booking.driver_image = profile.profile_image
            ? profile.profile_image
            : "";
          booking.car_image = profile.car_image ? profile.car_image : "";
          booking.driver_name = profile.firstName + " " + profile.lastName;
          booking.driver_contact = profile.mobile;
          booking.driver_token = profile.pushToken ? profile.pushToken : "";
          booking.vehicle_number = vehicleNumber || "";
          booking.driverRating = profile.rating ? profile.rating : "0";
          booking.fleetadmin = profile.fleetadmin ? profile.fleetadmin : "";
          booking.driver_share = driver_fee;
          (booking.fleetCommission = profile.fleetadmin
            ? (
                ((parseFloat(booking.estimate) -
                  parseFloat(booking.convenience_fees)) *
                  parseFloat(booking.fleet_admin_comission)) /
                100
              ).toFixed(2)
            : null),
            (booking.status = "ACCEPTED");
          booking.driverDeviceId = task.driverDeviceId
            ? task.driverDeviceId
            : null;
          booking.requestedDrivers = null;
          booking.driverEstimates = null;
          return booking;
        }
      }).then(() => {
        get(singleBookingRef(task.id))
          .then((snapshot) => {
            if (!snapshot.exists()) {
              return;
            } else {
              let requestedDrivers =
                snapshot.val() && snapshot.val().requestedDrivers;
              let driverId = snapshot.val() && snapshot.val().driver;

              if (requestedDrivers == undefined && driverId === uid) {
                updateProfile({
                  queue: snapshot.val().category === "delivery" ? false : true,
                })(dispatch);
                if (task.customer_token) {
                  RequestPushMsg(task.customer_token, {
                    title:
                      store.getState().languagedata.defaultLanguage
                        .notification_title,
                    msg:
                      profile.firstName +
                      store.getState().languagedata.defaultLanguage
                        .accept_booking_request,
                    screen: "BookedCab",
                    params: { bookingId: task.id },
                  });
                }

                const driverLocation = store.getState().gpsdata.location;

                push(trackingRef(task.id), {
                  at: new Date().getTime(),
                  status: "ACCEPTED",
                  lat: driverLocation.lat,
                  lng: driverLocation.lng,
                });

                dispatch({
                  type: ACCEPT_TASK,
                  payload: { task: task },
                });
              }
            }
          })
          .catch((error) => {
            console.error(error);
          });
      });
    },
    { onlyOnce: true }
  );
};

export const cancelTask = (bookingId) => (dispatch) => {
  const { auth, singleBookingRef } = firebase;

  const uid = auth.currentUser.uid;

  runTransaction(singleBookingRef(bookingId), (booking) => {
    if (booking && booking.requestedDrivers) {
      if (
        booking.requestedDrivers !== null &&
        Object.keys(booking.requestedDrivers).length === 1
      ) {
        booking.status = "NEW";
        booking.requestedDrivers = null;
        booking.driverEstimates = null;
        if (booking.customer_token) {
          RequestPushMsg(booking.customer_token, {
            title:
              store.getState().languagedata.defaultLanguage.notification_title,
            msg:
              store.getState().languagedata.defaultLanguage.booking_cancelled +
              bookingId,
            screen: "BookedCab",
            params: { bookingId: bookingId },
          });
        }
        dispatch({
          type: CANCEL_TASK,
          payload: { uid: uid, bookingId: bookingId },
        });
      } else {
        delete booking.requestedDrivers[uid];
      }
      if (booking.driverOffers && booking.driverOffers[uid]) {
        delete booking.driverOffers[uid];
      }
      if (booking.selectedBid && booking.selectedBid.driver === uid) {
        delete booking.selectedBid;
      }
      return booking;
    }
  });
};
